import PropTypes from 'prop-types';

const cicRevisionPropTypes = PropTypes.shape({
  changedByName: PropTypes.string,
  changedDate: PropTypes.string,
  previousCicReasonId: PropTypes.string,
  previousReasonName: PropTypes.string,
  previousComment: PropTypes.string,
  newCicReasonId: PropTypes.string,
  newReasonName: PropTypes.string,
  newComment: PropTypes.string,
});

export const cicChangePropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  field: PropTypes.string,
  label: PropTypes.string,
  oldDisplay: PropTypes.string,
  newDisplay: PropTypes.string,
  cicReasonId: PropTypes.string,
  reasonName: PropTypes.string,
  comment: PropTypes.string,
  changedByName: PropTypes.string,
  changedDate: PropTypes.string,
  status: PropTypes.string,
  removalCause: PropTypes.string,
  editable: PropTypes.bool,
  revisions: PropTypes.arrayOf(cicRevisionPropTypes),
});

export const cicFeeChangePropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  feeTypeId: PropTypes.string,
  feeName: PropTypes.string,
  oldDisplay: PropTypes.string,
  newDisplay: PropTypes.string,
  cicReasonId: PropTypes.string,
  reasonName: PropTypes.string,
  comment: PropTypes.string,
  changedByName: PropTypes.string,
  changedDate: PropTypes.string,
  status: PropTypes.string,
  editable: PropTypes.bool,
});
